import { render, staticRenderFns } from "./ProductUpdateRelationInvoice.vue?vue&type=template&id=5d0af0ac&"
import script from "./ProductUpdateRelationInvoice.vue?vue&type=script&lang=js&"
export * from "./ProductUpdateRelationInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports